import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { CollateralskillsetAddComponent } from './collateralskillset-add/collateralskillset-add.component';
import { PropertyTypeAddComponent } from './property-type-add/property-type-add.component';

@Component({
    selector: 'app-collateralskillsets',
    templateUrl: './collateralskillsets.component.html',
    styleUrls: ['./collateralskillsets.component.css']
})
export class CollateralskillsetsComponent implements OnInit {

    constructor(public dialog: MatDialog) { }

    ngOnInit() {

    }
    openCollateralSkillSetAddDialog() {
        this.dialog.open(CollateralskillsetAddComponent,
            {
                height: "340px",
                width:"410px"
            });
    }

    openPropertyTypeAddDialog() {
        this.dialog.open(PropertyTypeAddComponent,
            {
                height: "360px",
                width: "510px",
                panelClass: "property-type-screen"
            });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/collateralskillsets.component.ts